module.exports = __webpack_public_path__ + "static/img/good.57e1f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/good.png
// module id = kH51
// module chunks = 1